<template>
  <div id="app">
    <div style="
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: -10;
        background-image: url(../images/lottery.png);
        background-repeat: no-repeat;
        background-position: 0px 0px;
        background-size: 100% 100%;
    ">
    <BiorunLottery />
    </div>
  </div>
</template>

<script>
import BiorunLottery from "./components/BiorunLottery";

export default {
  name: 'App',
  components: {
    BiorunLottery
  }
}
</script>

<style>
body{margin:0;}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
